import React, { useState } from 'react';
import { adminAPI } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { toast } from 'sonner';
import { Pencil, Eye, Scale, CheckCircle, Loader2 } from 'lucide-react';

export const LegalTab = () => {
  const [editing, setEditing] = useState(null);
  const [content, setContent] = useState('');
  const [saving, setSaving] = useState(false);

  const pages = [
    { key: 'cgv', label: 'CGV', desc: 'Conditions Générales de Vente' },
    { key: 'mentions-legales', label: 'Mentions légales', desc: 'Informations légales obligatoires' },
    { key: 'politique-cookies', label: 'Politique de cookies', desc: 'Gestion des cookies (RGPD)' },
  ];

  return (
    <>
      <div className="space-y-6" data-testid="admin-legal-pages">
        <h3 className="font-heading text-lg font-bold text-white">Pages légales</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {pages.map(page => (
            <div key={page.key} className="bg-[#1A1A1A] rounded-2xl border border-[#2A2A2A] p-6">
              <div className="flex items-center gap-2 mb-2"><Scale className="w-5 h-5 text-[#00FF00]" /><h4 className="font-heading text-base font-bold text-white">{page.label}</h4></div>
              <p className="text-xs text-slate-500 mb-4">{page.desc}</p>
              <div className="flex gap-2">
                <Button onClick={async () => { try { const res = await adminAPI.getLegalPage(page.key); setContent(res.data?.content || ''); setEditing(page); } catch { setContent(''); setEditing(page); } }} className="bg-[#00FF00] text-black hover:bg-[#00CC00] font-bold text-xs flex-1" data-testid={`legal-edit-${page.key}`}><Pencil className="w-3 h-3 mr-1" /> Modifier</Button>
                <Button variant="outline" onClick={() => window.open(`/${page.key}`, '_blank')} className="border-[#2A2A2A] text-slate-300 hover:bg-[#111] text-xs" data-testid={`legal-view-${page.key}`}><Eye className="w-3 h-3 mr-1" /> Voir</Button>
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs text-slate-600 text-center">Le contenu accepte le HTML. Les liens sont affichés dans le footer du site.</p>
      </div>

      <Dialog open={!!editing} onOpenChange={(open) => { if (!open) setEditing(null); }}>
        <DialogContent className="sm:max-w-3xl bg-[#1A1A1A] border-[#2A2A2A] max-h-[90vh] overflow-y-auto">
          <DialogHeader><DialogTitle className="font-heading text-white">{editing?.label}</DialogTitle><DialogDescription className="text-slate-500">{editing?.desc} — Contenu HTML accepté</DialogDescription></DialogHeader>
          <div className="space-y-4">
            <Textarea value={content} onChange={e => setContent(e.target.value)} rows={20} placeholder="<h2>Titre</h2><p>Contenu de la page...</p>" className="bg-[#0A0A0A] border-[#2A2A2A] text-white font-mono text-sm resize-none" data-testid="legal-content-editor" />
            <p className="text-xs text-slate-600">Variables HTML supportées : &lt;h1&gt;, &lt;h2&gt;, &lt;h3&gt;, &lt;p&gt;, &lt;ul&gt;, &lt;ol&gt;, &lt;li&gt;, &lt;a&gt;, &lt;strong&gt;, &lt;em&gt;</p>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setEditing(null)} className="text-slate-400">Annuler</Button>
            <Button disabled={saving} onClick={async () => { setSaving(true); try { await adminAPI.updateLegalPage(editing.key, { content }); toast.success('Page mise à jour'); setEditing(null); } catch { toast.error('Erreur lors de la sauvegarde'); } setSaving(false); }} className="bg-[#00FF00] text-black hover:bg-[#00CC00] font-bold" data-testid="legal-save-btn">{saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <CheckCircle className="w-4 h-4 mr-2" />}Enregistrer</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
